export const GET_INVESTORS_REQUEST = 'GET_INVESTORS_REQUEST';
export const GET_INVESTORS_SUCCESS = 'GET_INVESTORS_SUCCESS';
export const GET_INVESTORS_FAILURE = 'GET_INVESTORS_FAILURE';

export const GET_INVESTOR_BY_ID_REQUEST = 'GET_INVESTOR_BY_ID_REQUEST';
export const GET_INVESTOR_BY_ID_SUCCESS = 'GET_INVESTOR_BY_ID_SUCCESS';
export const GET_INVESTOR_BY_ID_FAILURE = 'GET_INVESTOR_BY_ID_FAILURE';

export const GET_INVESTMENT_VIEW_DETAILS_REQUEST = 'GET_INVESTMENT_VIEW_DETAILS_REQUEST';
export const GET_INVESTMENT_VIEW_DETAILS_SUCCESS = 'GET_INVESTMENT_VIEW_DETAILS_SUCCESS';
export const GET_INVESTMENT_VIEW_DETAILS_FAILURE = 'GET_INVESTMENT_VIEW_DETAILS_FAILURE';

export const GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_REQUEST = 'GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_REQUEST';
export const GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_SUCCESS = 'GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_SUCCESS';
export const GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_FAILURE = 'GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_FAILURE';

export const DELETE_INVESTOR_REQUEST = 'DELETE_INVESTOR_REQUEST';
export const DELETE_INVESTOR_SUCCESS = 'DELETE_INVESTOR_SUCCESS';
export const DELETE_INVESTOR_FAILURE = 'DELETE_INVESTOR_FAILURE';

export const SAVE_INVESTOR_REQUEST = 'SAVE_INVESTOR_REQUEST';
export const SAVE_INVESTOR_SUCCESS = 'SAVE_INVESTOR_SUCCESS';
export const SAVE_INVESTOR_FAILURE = 'SAVE_INVESTOR_FAILURE';

export const DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_REQUEST = 'DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_REQUEST';
export const DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_SUCCESS = 'DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_SUCCESS';
export const DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_FAILURE = 'DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_FAILURE';

export const GET_PREFERRED_BULK_DATA_REQUEST = 'GET_PREFERRED_BULK_DATA_REQUEST';
export const GET_PREFERRED_BULK_DATA_SUCCESS = 'GET_PREFERRED_BULK_DATA_SUCCESS';
export const GET_PREFERRED_BULK_DATA_FAILURE = 'GET_PREFERRED_BULK_DATA_FAILURE';

export const GET_CATCHUP_BULK_DATA_REQUEST = 'GET_CATCHUP_BULK_DATA_REQUEST';
export const GET_CATCHUP_BULK_DATA_SUCCESS = 'GET_CATCHUP_BULK_DATA_SUCCESS';
export const GET_CATCHUP_BULK_DATA_FAILURE = 'GET_CATCHUP_BULK_DATA_FAILURE';

export const GET_HOLDCO_BULK_DATA_REQUEST = 'GET_HOLDCO_BULK_DATA_REQUEST';
export const GET_HOLDCO_BULK_DATA_SUCCESS = 'GET_HOLDCO_BULK_DATA_SUCCESS';
export const GET_HOLDCO_BULK_DATA_FAILURE = 'GET_HOLDCO_BULK_DATA_FAILURE';

export const SAVE_PREFERRED_BULK_DATA_REQUEST = 'SAVE_PREFERRED_BULK_DATA_REQUEST';
export const SAVE_PREFERRED_BULK_DATA_SUCCESS = 'SAVE_PREFERRED_BULK_DATA_SUCCESS';
export const SAVE_PREFERRED_BULK_DATA_FAILURE = 'SAVE_PREFERRED_BULK_DATA_FAILURE';

export const SAVE_CATCHUP_BULK_DATA_REQUEST = 'SAVE_CATCHUP_BULK_DATA_REQUEST';
export const SAVE_CATCHUP_BULK_DATA_SUCCESS = 'SAVE_CATCHUP_BULK_DATA_SUCCESS';
export const SAVE_CATCHUP_BULK_DATA_FAILURE = 'SAVE_CATCHUP_BULK_DATA_FAILURE';

export const SAVE_HOLDCO_BULK_DATA_REQUEST = 'SAVE_HOLDCO_BULK_DATA_REQUEST';
export const SAVE_HOLDCO_BULK_DATA_SUCCESS = 'SAVE_HOLDCO_BULK_DATA_SUCCESS';
export const SAVE_HOLDCO_BULK_DATA_FAILURE = 'SAVE_HOLDCO_BULK_DATA_FAILURE';

export const EXPORT_EQUITY_USER_REQUEST = 'EXPORT_EQUITY_USER_REQUEST';
export const EXPORT_EQUITY_USER_SUCCESS = 'EXPORT_EQUITY_USER_SUCESS';
export const EXPORT_EQUITY_USER_FAILURE = 'EXPORT_EQUITY_USER_FAILURE';

export const IMPORT_EQUITY_USER_REQUEST = 'IMPORT_EQUITY_USER_REQUEST';
export const IMPORT_EQUITY_USER_SUCCESS = 'IMPORT_EQUITY_USER_SUCESS';
export const IMPORT_EQUITY_USER_FAILURE = 'IMPORT_EQUITY_USER_FAILURE';

export const CLEAR_EQUITY_USER_EXPORT = 'CLEAR_EQUITY_USER_EXPORT';
export const CLEAR_IMPORT_EQUITY_USER_SUCCESS = 'CLEAR_IMPORT_EQUITY_USER_SUCCESS';

export const CLEAR_INVESTOR_DETAILS = 'CLEAR_INVESTOR_DETAILS';

export const PUBLISH_INVESTMENT_REQUEST = 'PUBLISH_INVESTMENT_REQUEST';
export const PUBLISH_INVESTMENT_SUCCESS = 'PUBLISH_INVESTMENT_SUCCESS';
export const PUBLISH_INVESTMENT_FAILURE = 'PUBLISH_INVESTMENT_FAILURE';
export const CLEAR_PUBLISH_INVESTMENT = 'CLEAR_PUBLISH_INVESTMENT';

export const FETCH_EQUITY_IMPORT_BATCH_LIST_REQUEST = 'FETCH_EQUITY_IMPORT_BATCH_LIST_REQUEST';
export const FETCH_EQUITY_IMPORT_BATCH_LIST_SUCCESS = 'FETCH_EQUITY_IMPORT_BATCH_LIST_SUCCESS';
export const FETCH_EQUITY_IMPORT_BATCH_LIST_FAILURE = 'FETCH_EQUITY_IMPORT_BATCH_LIST_FAILURE';

export const DOWNLOAD_EQUITY_IMPORT_RECORDS_REQUEST = 'DOWNLOAD_EQUITY_IMPORT_RECORDS_REQUEST';
export const DOWNLOAD_EQUITY_IMPORT_RECORDS_SUCCESS = 'DOWNLOAD_EQUITY_IMPORT_RECORDS_SUCCESS';
export const DOWNLOAD_EQUITY_IMPORT_RECORDS_FAILURE = 'DOWNLOAD_EQUITY_IMPORT_RECORDS_FAILURE';